// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2kIai","buttons":"styles_buttons__W2A_E"};